import React, { useState, useRef } from 'react';

import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import ForgotPassword1 from './ForgotPassword1';
import SecurityQuestionStep from '../shared/SecurityQuestionStep';
import ForgotPassword3 from './ForgotPassword3';
import ForgotPassword4 from './ForgotPassword4';
import { PrestoLink } from '../../atoms';
import { Header, Error, StepTracker } from '../../molecules';
import './forgot.scss';
import '../ForgotUsername/forgot.scss';

const stepsMap = [ForgotPassword1, SecurityQuestionStep, ForgotPassword3, ForgotPassword4];

function ForgotPassword({ fields, t }) {
  const [step, setStep] = useState(0);
  const focusDiv = useRef();
  const [isServerError, setIsServerError] = useState(false);
  const toNextStep = () => {
    setStep(step + 1);
    focusDiv.current.focus();
  };
  const Stepper = stepsMap[step];
  const [state, setState] = useState({
    questions: [],
  });

  return (
    <div className="forgot ">
      <span tabIndex="-1" ref={focusDiv} className="stepper-sr-only">
        {t('StepperChangeSRText')}
      </span>
      <StepTracker
        activeIndex={step}
        items={[
          {
            text: <Text field={fields.step1Title} />,
            textA11y: fields.step1TitleA11y.value,
          },
          {
            text: <Text field={fields.step2Title} />,
            textA11y: fields.step2TitleA11y.value,
          },
          {
            text: <Text field={fields.step3Title} />,
            textA11y: fields.step3TitleA11y.value,
          },
          {
            text: <Text field={fields.step4Title} />,
            textA11y: fields.step4TitleA11y.value,
          },
        ]}
      />
      <Header centered>
        <Text field={fields.heading} />
      </Header>
      <div className="forgot-content-wrapper">
        {/* eslint-disable-next-line no-nested-ternary */}
        {isServerError ? (
          typeof isServerError === 'object' ? (
            <Error
              text={<PrestoLink field={fields.needSomeHelpLink} className="help-link" />}
              title={isServerError.text}
            />
          ) : (
            <Error title={fields.errorUnableToProccess.value} />
          )
        ) : (
          <Stepper
            t={t}
            setIsServerError={setIsServerError}
            state={state}
            setState={setState}
            toNextStep={toNextStep}
            fields={fields}
            apiUrl="validateSecurityQAForgotPassword"
            length={50}
            securityQuestionSubmitsForm={false}
          />
        )}
        <div className="forgot-policy">
          <RichText field={fields.policy} />
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(ForgotPassword);
